import { ReactNode } from "react";

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  intro: string;
  children?: ReactNode;
};

const PageHero = ({ eyebrow, title, intro, children }: PageHeroProps) => {
  return (
    <section className="relative overflow-hidden pt-28 sm:pt-36 pb-14 sm:pb-20 border-b border-border">
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center opacity-[0.14]"
        style={{ backgroundImage: "url('/hero-bg.png')" }}
        aria-hidden
      />
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-background/70 via-background/92 to-background" aria-hidden />

      <div className="container mx-auto px-4">
        <div className="max-w-4xl animate-fade-in">
          <div className="flex items-center gap-3 mb-6">
            <span className="rule-gold" aria-hidden />
            <p className="eyebrow">{eyebrow}</p>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-[3.5rem] font-semibold leading-[1.06] mb-6">{title}</h1>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-3xl">{intro}</p>
          {children && <div className="mt-10 flex flex-col sm:flex-row gap-4">{children}</div>}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
